@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

$gap: var(--cxy-spacing-xxxsm);

[data-fpsm-theme='gazzetta'] {
  .button {
    color: var(--cxy-color-content-muted);
    opacity: 1;

    svg {
      color: var(--cxy-color-content-muted);
      fill: var(--cxy-color-content-muted);
      opacity: 1;
    }
  }

  .content {
    color: var(--cxy-color-text-default-body);
  }
}

.content {
  @include cxy.font-size('text-xxs');
  background-color: var(--cxy-color-surface-page);
  color: var(--cxy-color-text-default-placeholder);
  margin: calc(var(--cxy-spacing-3) * -1);
  padding: var(--cxy-spacing-xxsm);
  border-radius: var(--cxy-border-radius-m);
  border: none;
  box-shadow: var(--cxy-box-shadow-b);
  user-select: none;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  max-width: 205px;
  z-index: var(--cxy-z-index-tooltip);

  &[data-state='delayed-open'][data-side='top'] {
    animation-name: slideDownAndFade;
  }
  &[data-state='delayed-open'][data-side='right'] {
    animation-name: slideLeftAndFade;
  }
  &[data-state='delayed-open'][data-side='bottom'] {
    animation-name: slideUpAndFade;
  }
  &[data-state='delayed-open'][data-side='left'] {
    animation-name: slideRightAndFade;
  }
}

.arrow {
  fill: var(--cxy-color-surface-page);
  height: 10px;
  width: 10px;
}

.button {
  height: max-content;
}

@keyframes slideUpAndFade {
  from {
    opacity: 0;
    transform: translateY($gap);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideRightAndFade {
  from {
    opacity: 0;
    transform: translateX(-($gap));
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideDownAndFade {
  from {
    opacity: 0;
    transform: translateY(-($gap));
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideLeftAndFade {
  from {
    opacity: 0;
    transform: translateX($gap);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
